import { Controller, useFormContext } from 'react-hook-form'

import { FF2, TextInput, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const PhoneNumber = () => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name="institutionContactInfo.phone"
      control={control}
      rules={{ validate: Validators.required.field }}
      render={({ field }) => (
        <FF2
          required
          label="94. Phone number"
          field={field}
          input={(props) => <TextInput {...props} maxLength={16} data-qa="94. Phone number" />}
        />
      )}
    />
  )
}
